import React from 'react';
import PropTypes from 'prop-types';
import QuizCardNew from '../../shared/QuizCardNew';
import Spinner from '../../shared/spinner';

function DailyMcqsNew({ data, loading }) {
  if (loading) {
    return <Spinner />;
  }
  return (
    <div className="pt-[34px] lg:pt-[52px]">
      <QuizCardNew
        sectionTitle={data?.getListContents?.list?.name}
        page={data?.getListContents?.list?.name}
        data={data?.getListContents?.contents}
        entityID={data?.getListContents?.list?.id}
      />
    </div>
  );
}

export default DailyMcqsNew;

DailyMcqsNew.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};
